import { Upgrade } from "components/TopBar/Upgrade";
import { FREE_PLAN } from "constants/subscriptionType";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import authContext from "jwt_context&axios/authContext";
import { useContext } from "react";
import "static/styles/containers/dashboard.css";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { TaxSubscriptionModal } from "./TaxSubscriptionModal";
import { useModal } from "hooks/useModal";
import { useGetSubscriptionsQuery } from "store/apis/subscriptions";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { SubscriptionCards } from "components/SubscriptionModal/SubscriptionCards";
import Async from "components/DesignSystem/AsyncComponents/Async";
import { AddonData } from "store/slices/addons";
import { DiamondPurple } from "components/icons/DiamondPurple";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { SubscriptionInProfile } from "types/Models/subscription";
import { VerticalDivider } from "components/design/VerticalDivider";
import { useDispatch } from "react-redux";
import { setSubscriptionSummaryModalOpen } from "store/slices/subscriptionSummary";

export const UpgradeTaxPlan = () => {
  const { isCustomer, isInvestor } = useRoleBasedView();
  const { authtoken } = useContext(authContext);

  const currentPlan = authtoken?.platform_subscription?.subscription_name;
  const shouldUpgrade = !currentPlan || currentPlan === FREE_PLAN;
  const shouldShowUpgrade = Boolean(isCustomer && shouldUpgrade && !isInvestor);
  const currentEntityId = useCurrentEntityId();
  const { uuid: groupId } = useCurrentGroupContext();
  const taxSubscriptionsModal = useModal();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    data: subscribedPlans,
    isLoading,
    isSuccess,
  } = useGetSubscriptionsQuery({
    groupId,
    entityId: currentEntityId,
    subscription_types: "PLATFORM",
  });

  const handleOpenSummaryModal = (features: AddonData) => {
    history.push("/settings/billing");
    dispatch(setSubscriptionSummaryModalOpen(true));
  };

  const { groupId: currentGroup } = useParams<{ groupId?: string }>();
  const { platform_subscription: groupPlatformSubscription } =
    useCurrentGroupContext();

  let {
    platform_subscription: currentSubscription,
  }: {
    platform_subscription: SubscriptionInProfile;
  } = authtoken || {};

  if (currentGroup) {
    currentSubscription = groupPlatformSubscription;
  }

  const { data: subscribedPlansInlcudingInactive } = useGetSubscriptionsQuery({
    groupId,
    entityId: currentEntityId,
    subscription_types: "PLATFORM",
    get_inactive: true,
  });

  const depricatedTaxSubscription = subscribedPlansInlcudingInactive?.find(
    (item) => item.uuid === currentSubscription?.subscription_uuid
  );
  const latestTaxSubscription = subscribedPlans?.find(
    (item) => item?.group_subscription?.length
  );
  const features = depricatedTaxSubscription || latestTaxSubscription;

  const location = useLocation();
  const isBilling = location.pathname.includes("billing");
  if (isBilling) {
    return null;
  }

  if (!features || shouldShowUpgrade) {
    return (
      <>
        <Upgrade onUpgrade={() => taxSubscriptionsModal.open()} enableDivider />
        {taxSubscriptionsModal.isOpen && (
          <TaxSubscriptionModal
            show={taxSubscriptionsModal.isOpen}
            onClose={taxSubscriptionsModal.close}
            entityId={currentEntityId}
            groupId={groupId}
          />
        )}
      </>
    );
  }

  if (!isSuccess || isLoading) {
    return;
  }
  return (
    <>
      <Dropdown.Root modal={false}>
        <Dropdown.Trigger className="t-border-0" asChild>
          <div className="t-flex t-items-center t-gap-2">
            <div className="t-flex t-items-center t-gap-1 t-cursor-pointer t-text-purple-55 t-text-body-sm t-font-medium t-rounded-[3.125rem] t-bg-upgrade-gradient t-p-2">
              <DiamondPurple height={12} width={12} />
              <div>Standard</div>
            </div>
            <VerticalDivider />
          </div>
        </Dropdown.Trigger>
        <Dropdown.Content
          align="end"
          sideOffset={8}
          className="t-w-[28.125rem]"
        >
          <Async.Root
            isEmpty={false}
            isLoading={isLoading}
            isSuccess={isSuccess}
          >
            <Async.Success>
              {features && (
                <div className="t-p-2">
                  <SubscriptionCards
                    plan={features?.subscription_name}
                    features={
                      features?.metadata?.comparison?.length
                        ? features?.metadata?.comparison
                        : []
                    }
                    price={features.amount}
                    billingCycle={
                      features?.billing_cycle === "MONTHLY" ? "month" : "year"
                    }
                    title="SOFTWARE SUBSCRIPTION"
                    onManage={() => handleOpenSummaryModal(features)}
                    addon={features!}
                  />
                </div>
              )}
            </Async.Success>
          </Async.Root>
        </Dropdown.Content>
      </Dropdown.Root>
    </>
  );
};
